import { render, staticRenderFns } from "./InputsSegment.vue?vue&type=template&id=2c805058&"
import script from "./InputsSegment.vue?vue&type=script&lang=js&"
export * from "./InputsSegment.vue?vue&type=script&lang=js&"
import style0 from "./InputsSegment.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports